import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import MinPlanPrice from "../../Components/MinPlanPrice";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function CloudHosting() {
    const [applyPaddingClass, setApplyPaddingClass] = useState(false);
    useEffect(() => {
    document.title = "Powerful Cloud hosting - Built for Speed, Security & Scale";
        sal();
    }, []);

    const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
      <Helmet>
        <title>Powerful Cloud hosting - Built for Speed, Security & Scale</title>
        <meta name="description" content="With our cloud hosting run your website on high-performance, flexible scaling, strong security, and reliable uptime for modern digital success." />
        <meta name="keywords" content="Best Cloud Hosting, Cloud Web Hosting, Cloud Based Hosting Providers, Cloud Hosting Price, Best Cloud Hosting Providers, Cloud Hosting Companies, Best Cloud Server Hosting, Cloud Based Hosting, Cloud Web Hosting Services, Best Cloud Hosting Services, The Best Cloud Hosting, Top Cloud Hosting, Best Cloud Web Hosting Providers, Best Cloud Web Hosting, Best Cloud Web Hosting Services, Cloud Hosting" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/cloud-hosting`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/cloud-hosting`} />
        <meta property="og:title" content="Find the Best Cloud Hosting Services for High-Performance" />
        <meta property="og:description" content="Check out the best cloud hosting services that provide scalability & security for your business. Get affordable solutions & high uptime with reliable providers." />
      </Helmet>
      <section className="banner-bg bg-dark ssl-banner">
          <div className="container">
              <div className="row align-items-center g-4">
                  <div className="col-xl-6">
                      <div className="pb-40">
                          <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Flexible. Reliable. Cloud-Powered.</span>
                          <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">No Delays, No Downtime: Our Cloud Solutions</h1>
                          <div className="text-white mb-8 max-text-60 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"> <p>Harness the potential of our cloud hosting solutions and experience seamless data security across different servers. No Interruptions, Just High Uptime!</p>
                            <ul>
                                <li>Cost Savings, Even Enhanced Impact.</li>
                                <li>Struggle-Free Migration, No Crash.</li>
                            </ul> 
                          </div>
                          <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">View All Plans
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                                </span>
                            </button>
                            <MinPlanPrice category="cloud-hosting" />
                         </div>
                        <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                      </div>
                  </div>
                  <div className="col-xl-6 col-xxl-6"><div className="cloud-hero__img sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine"><img alt="image" className="img-fluid full-width-img" src="/images/zero-delay-zero-downtime.webp"/></div></div>
              </div>
          </div>
      </section>
      <section className="simple-box-section pb-100">
        <div className="container">
          <div className="row">
              <div className="col-12">
                  <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <div className="card-body px-6 pt-60 pb-60">
                          <div className="row justify-content-center">
                              <div className="col-md-11 col-lg-8 col-xl-8">
                                  <div className="text-center">
                                    <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Your Site's Ideal Match</span>
                                      <h4 className="mb-4">
                                          Your Ideal Server Awaits: Managed Cloud Hosting
                                      </h4>
                                      <p className="mb-6">
                                        Disappointed by frequent data loss, and slow-loading sites? What if there was a reliable way to end all this? With our managed cloud hosting plans, your site operates at lightning speed, remains secure, and handles high traffic effortlessly. 
                                      </p>
                                      <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded open-live-chat btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              Talk to an Expert
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </section>
      <div className="pt-100 pb-100 cloud-hosting-points-section">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center justify-content-xl-between">
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Cloud Hosting
                        </small>
                        <h2 className="mb-4">
                            Managed Cloud Hosting for Perfection. Soar Without Limits.
                        </h2>
                        <p className="max-text-56 mb-0 fw-semibold">
                            Flawless scalability, limitless success! Our best cloud web hosting services help you scale as per your business needs, with top-notch optimal performance, and supreme flexibility.
                        </p>
                    </div>
                    <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="card">
                            <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4 g-md-0 feature-list">
                <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="feature-list__card border text-center">
                        <div className="mb-8">
                            <img src="/images/stay-connected-accessible.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6 className="mb-5">
                            Stay Connected & Accessible
                        </h6>
                        <p className="mb-0">
                            Get a steadfast network that always keeps your site running without any interruption. No downtime, no delay-just seamless performance whenever you want.
                        </p>
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="feature-list__card border text-center">
                        <div className="mb-8">
                            <img src="/images/always-on.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6 className="mb-5">
                            Always On, Never Gone, 24/7
                        </h6>
                        <p className="mb-0">
                            No more crashes or security headaches. Our monitoring experts catch issues before they become challenging, keeping your servers always running without delays.
                        </p>
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                    <div className="feature-list__card border text-center">
                        <div className="mb-8">
                            <img src="/images/scale-smoothly.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6 className="mb-5">
                            Scale Smoothly, Work Peacefully
                        </h6>
                        <p className="mb-0">
                            With the help of our managed cloud hosting, you get the scalability to manage resources as required easily-no wasted costs, just unstoppable growth at your pace.
                        </p>
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="600" data-sal-easing="ease-in-out-sine">
                    <div className="feature-list__card border text-center">
                        <div className="mb-8">
                            <img src="/images/automatic-backups.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6 className="mb-5">
                            Timely Backups, Constant Growth
                        </h6>
                        <p className="mb-0">
                            Your website deserves more security than you think. Our cloud servers & hosting, keep your data automatically backed up, & protect your business from all threats. 
                        </p>
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="700" data-sal-easing="ease-in-out-sine">
                    <div className="feature-list__card border text-center">
                        <div className="mb-8">
                            <img src="/images/cloud-command.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6 className="mb-5">
                            Cloud Command, Always In Demand
                        </h6>
                        <p className="mb-0">
                            Our skilled cloud server providers guarantee smooth business working with support that never sleeps. Stay focused on your goals while we manage your server.
                        </p>
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="800" data-sal-easing="ease-in-out-sine">
                    <div className="feature-list__card border text-center">
                        <div className="mb-8">
                            <img src="/images/powerful-hardware.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6 className="mb-5">
                            Powerful Hardware, High Potential
                        </h6>
                        <p className="mb-0">
                           We power your success with cutting-edge cloud servers, guaranteeing high speed. No interruption-just the seamless performance that you want.
                        </p>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <section className="price-plan-section pt-100 pb-100">
          <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
          <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-8">
                          <div className="text-center">
                              <span className="section-title-dark style-bg fadeInUp" id="plans">Our Plans</span>
                              <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Your Demands - Our Solutions </h2>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <PlanList category={'cloud-hosting'}/>
      </section>
      <section className="pt-100 pb-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Grow With Us
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Cloud Hosting That Outshines, Where Your Business Grows</h2>
                        <p className="text-dark mb-0 max-text-56 mx-auto sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Uninterrupted scalability, no more delay-cloud servers easily enhance your business growth! Trustworthy, quick, and engineered for the long term, your hosting future is right here-incomparable!</p>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Perfect For WordPress</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/perfect-for-wordpress.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Boost your WordPress experience with our cloud hosting, built for high speed, security, and smooth management, so you can emphasize what genuinely matters.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Ideal Choice For E-commerce</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/ideal-choice.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Set up your online store in a few minutes-no tech expertise required. With Infinitive Host, setting up your e-commerce website is fast, seamless, and hassle-free.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Software, Engineered to Grow</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/software-engineered.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Run code without restrictions-our cloud servers scale as your vision exhibits! We offer the demanded power to let all your innovative ideas take wing.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Strong & Wide IT Infrastructure</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/strong-wide-it-infrastructure.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">From new businesses to large enterprises, we power it all-flexible cloud solutions that never stall! Just perform at its best, keeping your business powerful.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <div className="why-choose-section pt-100 pb-100">
        <div className="pb-60">
            <div className="container">
                <div className="row">
                    <div className="col-md-10 col-lg-8 col-xl-6 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <span className="d-flex align-items-center gap-2 mb-3">
                <span className="d-block w-2 h-2 rounded-circle bg-success"></span>
                        <span className="d-block text-white">
                  <span className="text-success">Cloud Hosting</span>, Simplified
                        </span>
                        </span>
                        <h2 className="mb-2 text-white">
                            Adaptable. Boundless. Quick Cloud Servers.
                        </h2>
                        <div className="text-white">
                            <p>Say hello to lightning-fast performance with our cloud servers and the best cloud hosting services, you get expert support and total peace of mind. Cloud servers in, stress out!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4 align-items-center justify-content-xl-between">
                <div className="col-lg-6 col-xxl-7">
                    <div className="cloud-hero__img sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="/images/adaptable-boundless.webp" alt="image" className="img-fluid"/>
                    </div>
                </div>
                <div className="col-lg-6 col-xl-5 col-xxl-4">
                    <ul className="list-unstyled vstack gap-4">
                        <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                            <div className="cloud-card">
                                <h6 className="cloud-card__title mb-4">High Uptime, 24/7 Reliability</h6>
                                <p className="mb-0 fs-14">
                                    Your site never sleeps, and neither our experts! Stay online all the time with a reliable 99.9% uptime guarantee-no issues, no worries!
                                </p>
                            </div>
                        </li>
                        <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                            <div className="cloud-card">
                                <h6 className="cloud-card__title mb-4">Performance Without Any Glitch</h6>
                                <p className="mb-0 fs-14">
                                    The speed that excites, resources that easily scale! With the help of SSD storage, HTTP/3, and a dedicated IP, get the performance-no technical skills are needed!
                                </p>
                            </div>
                        </li>
                        <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                            <div className="cloud-card">
                                <h6 className="cloud-card__title mb-4">User-Friendly Control Panel</h6>
                                <p className="mb-0 fs-14">
                                    We handle everything with full comfort! Our user-friendly control panel makes cloud hosting a breeze-no steep learning curves, just gentle sailing!
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
      </div>
      <section className="pt-100 pb-100">
        <div className="container">
            <div className="bg-white px-8 py-10 rounded-3">
                <div className="row align-items-center g-4">
                    <div className="col-lg-5">
                        <img src="/images/unmetered-mitigation.webp" alt="image" className="img-fluid sal-animate" data-sal="fade" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                    </div>
                    <div className="col-lg-7">
                        <div className="d-inline-flex align-items-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                              <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Migration Without Downtime
                            </small>
                        </div>
                        <h2 className="mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Unmetered Mitigation for Your Entire Server.</h2>
                        <p className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"> Effortlessly website migration to a cloud server is an intense process-downtime, data loss, and security headaches are the main issues. But with the help of our best cloud hosting services, you get a seamless, and stress-free transition managed by migration experts.</p>
                        <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate mt-5 btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                              <span className="btn-arrow__text">
                                  View All Plans
                                  <span className="btn-arrow__icon">
                                      <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                              </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
      </section>
    </>
  );
}
